export default [
  {
    path: "/verify",
    component: () => import(/* webpackChunkName: "verify" */ "@/views/global/Clear"),
    meta: { layout: "auth" },
    children: [
      {
        path: "ticket/:id",
        name: "verify.ticket",
        component: () => import(/* webpackChunkName: "verify" */ "@/views/proxy/TicketVerify"),
      },
      {
        path: "membership/:id",
        name: "verify.membership",
        component: () => import(/* webpackChunkName: "verify" */ "@/views/proxy/MembershipVerify"),
      },
      {
        path: "cashout/:id",
        name: "verify.cashout",
        component: () => import(/* webpackChunkName: "verify" */ "@/views/proxy/CashoutVerify"),
      },
      {
        path: "*",
        redirect: "/",
      },
    ],
  },
  {
    path: "/v",
    children: [
      {
        path: "t/:id",
        redirect: "/verify/ticket/:id",
      },
      {
        path: "m/:id",
        redirect: "/verify/membership/:id",
      },
      {
        path: "c/:id",
        redirect: "/verify/cashout/:id",
      },
      {
        path: "*",
        redirect: "/verify",
      },
    ],
  },
];
